import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Descriptions, Col, Row, Flex, Form, Select, Drawer, Modal } from 'antd';
import OrderService from "services/order"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate, useParams } from 'react-router';
import { useApp } from 'contexts/app';
import ProductVariantService from "services/product_variant"
import CustomerService from "services/customer"

import { PlusSquareOutlined, EditOutlined } from "@ant-design/icons"
import InputNumber from "components/input-number"
import { toSearchText } from "utils/text"

import { useWorkSpace } from "contexts/workspace"
import _ from "lodash"
import { useAddressPicker } from '.';


const service = new CustomerService();

const CustomerInfo = ({ id, open, onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { showLoading } = useApp();
    const { address, onChange } = useAddressPicker();

    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue(address);
    }, [address])

    useEffect(() => {
        setIsModalOpen(open)
    }, [open])

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const btnSaveClick = () => {
        form.submit();
    }
    const onFinish = async values => {

        onChange(values);
        onClose();

    };




    return (
        <>

            <Modal
                title="Sửa địa chỉ"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={open}
                onOk={handleOk}
                onCancel={onClose}
                footer={<Space>
                    <Button>Close</Button>
                    <Button onClick={btnSaveClick} type='primary'>Ok</Button>
                </Space>}
            >
                <Form layout='vertical' form={form}

                    onFinish={onFinish}

                >




                    <Form.Item
                        label="Số điện thoại"
                        name={"phone_number"}
                        rules={[

                            {
                                required: true,
                                pattern: /^[0-9]{10}$/,
                                message: "Số điện thoại không đúng định dạng",

                            },


                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Họ  và tên"
                        name={"full_name"}

                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Địa chỉ"
                        name={"address"}

                    >
                        <Input />
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
};
export default CustomerInfo;